import {i18nInstance} from "../localization/core"
import Skill from "./Skill";
import Service from "./Service";
import PricePlan, {PriceType} from "./PricePlan";
import Testimonial from "./Testimonial";


export default class Owner {
  static readonly instance = new Owner();

  readonly firstName = 'Ekcel Henrich'
  readonly lastName = 'Ekoumelong'
  readonly pseudo = 'GENL'
  readonly age = 23
  readonly city = 'Yaounde'
  readonly residenceCountry = 'Cameroon'

  readonly yearsExperience = 3
  readonly completedProjects = 14
  readonly happyCustomer = 13
  readonly honorsAndAwards = 1

  readonly githubRepoUrl = 'https://github.com/GENL/ekcel-portfolio'

  get languages(): { name: string, level: number }[] {
    return [
      {name: i18nInstance.t('commons.labels.french', '', ), level: 100},
      {name: i18nInstance.t('commons.labels.english'), level: 60},
    ]
  }

  readonly skills: Skill[] = [
    new Skill({name: 'Laravel', level: 95, years: 3}),
    new Skill({name: 'Flutter', level: 95, years: 3}),
    new Skill({name: 'Node.js', level: 80, years: 2}),
    new Skill({name: 'PHP', level: 90, years: 3}),
    new Skill({name: 'Javascript', level: 95, years: 3}),
    new Skill({name: 'Electron.js', level: 70, years: 1}),
    new Skill({name: 'Firebase', level: 80, years: 1}),
    new Skill({name: 'Vue.js', level: 95, years: 2}),
    new Skill({name: 'React.js', level: 84, years: 1}),
    new Skill({name: 'Adonis.js', level: 80, years: 1}),
    new Skill({name: 'Typescript', level: 95, years: 1}),
    new Skill({name: 'HTML / CSS', level: 95, years: 1}),
    new Skill({name: 'Agile', level: 77, years: 2}),
    new Skill({name: 'Git / Github / Gitlab', level: 80, years: 3}),
    new Skill({name: 'Restful API', level: 95, years: 3}),
  ]

  readonly secondarySkills: Skill[] = [
    new Skill({name: 'Vuetify, Element-UI, Bootstrap, Material-UI', level: 90, years: 1}),
    new Skill({name: 'Vuex, VueRouter', level: 98, years: 1}),
    new Skill({name: 'Alpine.js, Velocity', level: 98, years: 1}),
    new Skill({name: 'ReactRouter, Mobx, Redux', level: 70, years: 1}),
    new Skill({name: 'Stylus, Sass', level: 50, years: 1}),
    new Skill({name: 'Webpack', level: 50, years: 1}),
    new Skill({name: 'Socket.io', level: 50, years: 1}),
    new Skill({name: 'Gitflow', level: 90, years: 1}),
    new Skill({name: 'MTN Mobile Money, Orange Money', level: 50, years: 1}),
    new Skill({name: 'Project Management', level: 50, years: 1}),
  ]

  readonly socialMedias: {link: string, name: string, icon: string}[] = [
    {name: 'LinkedIn', link: 'https://www.linkedin.com/in/ekcel-henrich-248616189', icon: 'fab fa-linkedin-in'},
    {name: 'Github', link: 'https://github.com/GENL', icon: 'fab fa-github'},
    {name: 'Twitter', link: 'https://twitter.com/ekcel_henrich', icon: 'fab fa-twitter'},
  ]

  private constructor() {
  }

  get jobTitles(): string[] {
    return [
      i18nInstance.t('commons.owner.jobTitleMobileDev'),
      i18nInstance.t('commons.owner.jobTitleWebDev'),
    ]
  }

  get services(): Service[] {
    const localizedText = (key: string, isDesc = false) => {
      let desc = isDesc ? 'Desc' : ''
      return this.localizedText('service' + desc + key.substring(0, 1).toUpperCase() + key.substring(1))
    }

    const desc = (key: string) => localizedText(key, true)

    return [
      new Service({title: localizedText('flutter'), description: desc('flutter')}),
      new Service({title: localizedText('backend'), description: desc('backend')}),
      new Service({title: localizedText('frontend'), description: desc('frontend')}),
      new Service({title: localizedText('firebase'), description: desc('firebase')}),
      new Service({title: localizedText('mobileMoney'), description: desc('mobileMoney')}),
      new Service({title: localizedText('maps'), description: desc('maps')}),
      new Service({title: localizedText('sockets'), description: desc('sockets')}),
    ]
  }

  get thingsIBuild(): Service[] {
    const localizedText = (key: string) =>
      this.localizedText('thingBuild' + key.substring(0, 1).toUpperCase() + key.substring(1))
    return [
      new Service({title: localizedText('mobileApp'), description: ''}),
      new Service({title: localizedText('backend'), description: ''}),
      new Service({title: localizedText('desktop'), description: ''}),
      new Service({title: localizedText('web'), description: ''}),
      new Service({title: localizedText('laravelDepTools'), description: ''}),
    ]
  }

  get pricesPlans(): PricePlan[] {
    return [
      new PricePlan({
        title: i18nInstance.t('commons.labels.starterPlan'),
        priceCost: 0,
        supportedPriceTypes: [PriceType.specifications, PriceType.milestonesAdvice]
      }),
      new PricePlan({
        title: i18nInstance.t('commons.labels.specificTasksPlan'),
        priceCost: 30000,
        isFixedCost: false,
        supportedPriceTypes: 'all'
      }),
      /*new PricePlan({
        title: i18nInstance.t('commons.labels.fullTimePlan'),
        priceCost: 350000,
        supportedPriceTypes: 'all',
        priceUnitTime: 'm'
      }),*/
    ]
  }

  get fullName() {
    return `${this.firstName} ${this.lastName}`
  }

  get cvUrl(): string {
    return i18nInstance.language === 'en'
      ? 'https://cvdesignr.com/p/5efdf50b59f9e?hl=en_US'
      : 'https://cvdesignr.com/p/5d9379cfb2b5e?hl=fr_FR'
  }

  private localizedText(key: string) {
    return i18nInstance.t(`commons.owner.${key}`)
  }

  get testimonials(): Testimonial[] {
    return [
      new Testimonial('Gildas Tema', 'Développeur & Co-founder ArtisanPay', `J'ai été bluffé par son talent C'est l'un des meilleurs programmeurs avec qui j'ai travaillé.`, 5, {avatar: 'https://scontent-mia3-1.xx.fbcdn.net/v/t31.0-8/18891640_1676568042383713_4548648631023641498_o.jpg?_nc_cat=101&_nc_sid=09cbfe&_nc_ohc=qCccOOGLj80AX9M6mp9&_nc_ht=scontent-mia3-1.xx&oh=6d97e765f4bd07669e995d48ffc2cad4&oe=5F4FEE83'}),
      new Testimonial('Rykel', 'CEO Loli Digital', "Il a réalisé en un temps record notre application de gestion utilisé en interne. Je ne lui ai pas demandé un service qu'il n'a su faire. Tout de même il n'a pas aimé que l'appel à tout heure", 4)
    ]
  }
}

